import React from 'react';
import PropTypes from 'prop-types';
import Maybe from 'react-maybe';
import { Typo, Spinner } from '@ers/ui';
import { useSelectorWithDispatch, useModal } from '@ers/hooks/';
import { loadUser } from '@ers/root/App.actions';
import { getPersonalData } from '@ers/root/App.selectors';
import { Media } from '..';
import UserAvatar from './UserAvatar';
// eslint-disable-next-line import/no-named-as-default
import UserBox from './UserBox';





const UserHooked = () => {
    const userData = useSelectorWithDispatch(getPersonalData, loadUser, ({ firstName }) => firstName === undefined);
    return <User {...userData} />;
};

export const User = ({ firstname, avatar }) => {
    const [isVisible, openBox, hideBox] = useModal();
    const triggerBox = isVisible ? hideBox : openBox;
    const text = (content) => (
        <Typo.Body className="with-margin--left-1">
            {content}
        </Typo.Body>
    );
    return (
        <div style={{ position: 'relative' }}>
            <div className="topbar__avatar" onClick={triggerBox}>
                <Maybe
                    of={firstname}
                    either={(
                        <>
                            <UserAvatar avatar={avatar} />
                            <Media tabletLandscape desktop fullHD>
                                {text(firstname !== '' ? `Cześć ${firstname}!` : '')}
                            </Media>
                        </>
                    )}
                    orElse={(
                        <Media tabletLandscape desktop fullHD>
                            <UserAvatar />
                            {text(<Spinner.Dots />)}
                        </Media>
                    )}
                />
            </div>
            {isVisible && (
                <>
                    <UserBox close={hideBox} />
                    <div className="topbar__dropdown-layout" onClick={hideBox} />
                </>
            )}
        </div>
    );
};
User.propTypes = {
    firstname: PropTypes.string,
    avatar: PropTypes.string,
};
User.defaultProps = {
    firstname: undefined,
    avatar: undefined
};

export default UserHooked;